
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.406.656l3.89 3.938c.423.422.704 1.031.704 1.593V21.75A2.25 2.25 0 0115.75 24H2.25A2.221 2.221 0 010 21.75V2.25A2.25 2.25 0 012.25 0h9.563c.562 0 1.171.234 1.593.656zm3.013 5.27a.839.839 0 00-.153-.254l-3.938-3.938c-.071-.071-.17-.116-.255-.153L12 1.547V6h4.453l-.034-.073zM15.75 22.5H2.25a.74.74 0 01-.75-.75V2.25c0-.375.328-.75.75-.75h8.25v4.875c0 .656.469 1.125 1.125 1.125H16.5v14.25c0 .422-.375.75-.75.75zm-2.813-12c.282 0 .563.281.563.563v.374a.57.57 0 01-.563.563H5.064a.542.542 0 01-.563-.563v-.374a.57.57 0 01.563-.563h7.875zm.563 3.563c0-.282-.281-.563-.563-.563H5.064a.57.57 0 00-.563.563v.374c0 .329.234.563.563.563h7.875a.57.57 0 00.562-.563v-.374zm-.563 2.437c.282 0 .563.281.563.563v.375a.57.57 0 01-.563.562H5.064a.542.542 0 01-.563-.563v-.375a.57.57 0 01.563-.562h7.875z","fill":"#586E8C"}})])
          )
        }
      }
    